import "./App.css";
import RecruiterLogin from "./pages/Account/RecruiterLogin/RecruiterLogin";
import SelectCompany from "./pages/Account/RecruiterSignup/Select_company";
import Active_Tab from "./pages/Recruiter/pages/Active_Tab";
import Closed_Tab from "./pages/Recruiter/pages/Closed_Tab";
import Draft_Tab from "./pages/Recruiter/pages/Draft_Tab";
import Post_Job from "./pages/Recruiter/pages/Post_Job";
import Details_Page from "./pages/Recruiter/pages/Details_Page";
import SearchResult1 from "./pages/Recruiter/pages/SearchResult1";
import useIsAuth from "./hooks/useIsAuth";
import { Suspense, lazy, useEffect } from "react";
import { ProtectedRoute } from "./Components/ProtectedRoute";
import Navbar from "./Components/Recruiter/Navbar/Navbar";
import StudentNavbar from "./Components/Students/Navbar/Navbar.jsx";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
// import Save from './pages/Student/Saves/Save';
// import ChatPage from './pages/Student/Chatpages/ChatPage';
import Profile from "./Components/Students/userProfile";
import { useDispatch, useSelector } from "react-redux";
import { studentActions } from "./redux/actions";
import { ProtectedRouteStudent } from "./Components/Students/ProtectedRouteStudent";
import Company_profile from "./pages/Recruiter/pages/Company_profile";
import LandingPage from "./pages/LandingPage";
import Portfolio from "./pages/Recruiter/pages/Portfolio";

// Student
import Login from "./pages/Student/Login/";
import Signup from "./pages/Student/Signup";
import Upload from "./pages/Student/Upload/Upload.jsx";
import MyApplication from "./pages/Student/Myapplication";
import Invites from "./pages/Student/Invites";
// import Business from './pages/Student/Business/Business';
// import PortFolio from './pages/Student/PortFolio/PortFolio';
import EditProfile from "./Components/Students/EditProfile";
import Change_Password from "./Components/Students/ChangePassword";
// import Notification from './Components/Students/Notification/Notification';
import StartBuildingProject from "./pages/Student/StartBuildingProject/StartBuildProject";
import PostMarketLink from "./pages/PostMarketLink/PostMarketLink";
import PortFolio from "./pages/Student/PortFolio";
import Register from "./pages/Student/mulltistep_Registration";
import RecruiterSignup from "./pages/Account/MultistepSignup/Index";
import MultistepCompanySetup from "./pages/Account/MultistepCompany";
import { Forgot } from "./pages/Account/ForgotPassword/Forgot";
import { ResetPassword } from "./pages/Account/ResetPassword/ResetPassword";
import ChatList from "./Components/Chat/ChatList";
import Chat from "./pages/Recruiter/pages/Chat";
import { LandingPageSearch } from "pages/LandingPageSearch/LandingPageSearch";
import NewUpload from "./pages/Student/NewUpload/NewUpload";
import Priview from "Components/Students/PriviewCard/Priview";
import StudentProfile from "Components/Students/Profilev0.3.1/StudentProfile";
import Edit from "Components/Students/EditProfilev0.3.1/Edit";
import { UserCard } from "./Components/UserCard/UserCard";
import CompanyProfile from "Components/Students/CompanyProfile";
import { Mobileview } from "Components/Students/Profilev0.3.1/Mobileview";
import { Preloader } from "Components/Loader/Preloader";
import { CommonSignup } from "pages/Account/RecruiterLogin/Signup";
import { Privacy } from "Components/Common/Privacy";
import { TermsAndConditions } from "Components/Common/TermsAndConditions";
import { FaqButton } from "Components/FAQButton/FaqButton";
import { WithoutLoginNavbar } from "Components/Students/Navbar/NavbarWithoutLogin";
const FindJob = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(import("./pages/Student/Job")), 2000);
  });
});

function App() {
  const dispatch = useDispatch();
  const isAuth = useIsAuth();

  const student = useSelector((state) => state.student.data);
  const authUser = JSON.parse(localStorage.getItem("user"));

  // useEffect(() => {
  //   if (authUser.profile === 'ajna_student') {
  //     dispatch(studentActions.setStudents)
  //   }
  // }, [authUser])

  return (
    <div className="App">
      <BrowserRouter>
        {/* {authUser ? (
          authUser.profile === "ajna_student" && <FaqButton />
        ) : (
          <FaqButton />
        )} */}

        <Suspense fallback={<Preloader />}>
          <Routes>
            <Route path="*" element={<Navigate to={"/"} />} />
            <Route path="/" element={<RecruiterLogin />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/t&c" element={<TermsAndConditions />} />

            <Route path="/hiring/signup" element={<CommonSignup />} />
            {/* Recruiter */}
            <Route path="/hiring/recruiter/" element={<RecruiterLogin />} />
            <Route
              path="/hiring/recruiter/findtalent"
              element={
                <ProtectedRoute>
                  <LandingPageSearch />
                </ProtectedRoute>
              }
            />
            <Route
              path="/hiring/recruiter/chat"
              element={
                <ProtectedRoute>
                  <Chat type="recruiter" />
                </ProtectedRoute>
              }
            />
            <Route
              path="/hiring/recruiter/chat/:id"
              element={
                <ProtectedRoute>
                  <Chat type="recruiter" />
                </ProtectedRoute>
              }
            />
            <Route
              path="/hiring/student/chat"
              element={
                <ProtectedRouteStudent>
                  <Chat type="student" />
                </ProtectedRouteStudent>
              }
            />
            <Route
              path="/hiring/student/chat/:id"
              element={
                <ProtectedRouteStudent>
                  <Chat type="student" />
                </ProtectedRouteStudent>
              }
            />
            <Route
              path="/hiring/student/forgot-password/"
              element={<Forgot profile="ajna_student" />}
            />
            <Route
              path="/hiring/forgot-password/"
              element={<Forgot profile="recruiter" />}
            />
            <Route
              path="/hiring/student/regenratepassword/:email/:token"
              element={<ResetPassword />}
            />
            <Route
              path="/hiring/recruiter/regenratepassword/:email/:token"
              element={<ResetPassword />}
            />
            {/* <Route
            path='/hiring/recruiter/signup'
            element={<RecruiterSignup />}
          /> */}
            <Route
              path="/hiring/recruiter/signup"
              element={<RecruiterSignup />}
            />
            <Route
              path="/hiring/recruiter/selectCompany"
              element={
                <ProtectedRoute>
                  <SelectCompany />
                </ProtectedRoute>
              }
            />

            {/* <Route
            path="/hiring/recruiter/upload_profile"
            element={<RecruiterUpload />}
          /> */}

            {/* <Route
            path='/hiring/recruiter/setupCompany'
            element={<SetupCompany />}
          /> */}
            <Route
              path="/hiring/recruiter/setupCompany"
              element={
                <ProtectedRoute>
                  <MultistepCompanySetup />
                </ProtectedRoute>
              }
            />
            <Route
              path="/hiring/recruiter/active"
              element={
                <ProtectedRoute>
                  <Active_Tab />
                </ProtectedRoute>
              }
            />
            <Route
              path="/hiring/recruiter/closed"
              element={
                <ProtectedRoute>
                  <Closed_Tab />
                </ProtectedRoute>
              }
            />
            <Route
              path="/hiring/recruiter/draft"
              element={
                <ProtectedRoute>
                  <Draft_Tab />
                </ProtectedRoute>
              }
            />
            <Route
              path="/hiring/recruiter/studentprofile/:id"
              element={
                <ProtectedRoute>
                  {JSON.parse(localStorage.getItem("user"))?.profile ===
                    "recruiter" && <Navbar />}
                  {JSON.parse(localStorage.getItem("user"))?.profile ===
                    "ajna_student" && <StudentNavbar />}
                  {JSON.parse(localStorage.getItem("user"))?.profile ===
                    undefined && <WithoutLoginNavbar />}
                  <StudentProfile isShare={true} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/hiring/recruiter/createPost"
              element={
                <ProtectedRoute>
                  <Post_Job />
                </ProtectedRoute>
              }
            />
            <Route
              path="/hiring/recruiter/createPost/:id"
              element={
                <ProtectedRoute>
                  <Post_Job />
                </ProtectedRoute>
              }
            />
            <Route
              path="/hiring/recruiter/details/:id"
              element={
                <ProtectedRoute>
                  <Details_Page />
                </ProtectedRoute>
              }
            />
            <Route
              path="/hiring/recruiter/search"
              element={
                <ProtectedRoute>
                  <Navbar />
                  <SearchResult1 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/hiring/recruiter/profile"
              element={
                <ProtectedRoute>
                  <Navbar />
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/hiring/recruiter/Editprofile"
              element={
                <ProtectedRouteStudent>
                  <Navbar />
                  <EditProfile />
                </ProtectedRouteStudent>
              }
            />
            <Route
              path="/hiring/recruiter/change_password"
              element={
                <ProtectedRouteStudent>
                  <Navbar />
                  <Change_Password />
                </ProtectedRouteStudent>
              }
            />
            <Route
              path="/hiring/recruiter/manageCompany/:companyId"
              element={
                <ProtectedRouteStudent>
                  <Navbar />
                  <Company_profile />
                </ProtectedRouteStudent>
              }
            />
            {/* t&c */}
            <Route
              path="hiring/recruiter/t&c"
              element={
                <ProtectedRouteStudent>
                  <TermsAndConditions />
                </ProtectedRouteStudent>
              }
            />

            {/* Student */}

            <Route path="/" element={<RecruiterLogin />} />
            {/* <Route path='/hiring/student/signup' element={<Signup />} /> */}
            <Route path="/hiring/student/signup" element={<Register />} />
            <Route path="/hiring/student/Upload" element={<Upload />} />
            {/* <Route path="hiring/student/Photo_Upload" element={<Photo_Upload />} /> */}

            <Route
              path="/hiring/student/:postsType"
              element={
                <ProtectedRouteStudent>
                  <StudentNavbar />
                  <FindJob />
                </ProtectedRouteStudent>
              }
            />

            <Route
              path="/hiring/student/portfolio"
              element={
                <ProtectedRouteStudent>
                  <StudentNavbar />
                  <PortFolio />
                </ProtectedRouteStudent>
              }
            />

            <Route
              path="/hiring/student/preview/:studentId/:id"
              element={
                <>
                  {JSON.parse(localStorage.getItem("user"))?.profile ===
                    "recruiter" && <Navbar />}
                  {JSON.parse(localStorage.getItem("user"))?.profile ===
                    "ajna_student" && <StudentNavbar />}
                  {JSON.parse(localStorage.getItem("user"))?.profile ===
                    undefined && <WithoutLoginNavbar />}
                  <Priview />
                </>
              }
            />
            <Route
              path="/hiring/job-details/:jobid/:companyid"
              element={
                <>
                  {JSON.parse(localStorage.getItem("user"))?.profile ===
                    "recruiter" && <Navbar />}
                  {JSON.parse(localStorage.getItem("user"))?.profile ===
                    "ajna_student" && <StudentNavbar />}
                  {JSON.parse(localStorage.getItem("user"))?.profile ===
                    undefined && <WithoutLoginNavbar />}
                  <FindJob jobdetails={true} />
                </>
              }
            />
            <Route
              path="/hiring/student/Editprofile"
              element={
                <ProtectedRouteStudent>
                  <StudentNavbar />
                  <Edit />
                </ProtectedRouteStudent>
              }
            />
            <Route
              path="/hiring/student/profile"
              element={
                <ProtectedRouteStudent>
                  {JSON.parse(localStorage.getItem("user"))?.profile ===
                    "ajna_student" && <StudentNavbar />}
                  {JSON.parse(localStorage.getItem("user"))?.profile ===
                    "recruiter" && <Navbar />}

                  {JSON.parse(localStorage.getItem("user"))?.profile ===
                    undefined && <WithoutLoginNavbar />}
                  <StudentProfile />
                </ProtectedRouteStudent>
              }
            />
            <Route
              path="/hiring/student/upload"
              element={
                <ProtectedRouteStudent>
                  <StudentNavbar />
                  <StudentProfile />
                </ProtectedRouteStudent>
              }
            />
            <Route
              path="/hiring/student/change_password"
              element={
                <ProtectedRouteStudent>
                  <StudentNavbar />
                  <Change_Password />
                </ProtectedRouteStudent>
              }
            />

            <Route
              path="/hiring/student/StartBuildingProject"
              element={
                <ProtectedRouteStudent>
                  <StudentNavbar />
                  {/* <StartBuildingProject /> */}
                  <NewUpload />
                </ProtectedRouteStudent>
              }
            />
            <Route
              path="/hiring/student/editwork/:id"
              element={
                <ProtectedRouteStudent>
                  <StudentNavbar />
                  <NewUpload />
                </ProtectedRouteStudent>
              }
            />
            <Route
              path="hiring/student/PostMarketLink"
              element={
                <ProtectedRouteStudent>
                  <StudentNavbar />
                  <PostMarketLink />
                </ProtectedRouteStudent>
              }
            />
            {/* new routes */}
            <Route
              path="hiring/student/newUploadwork"
              element={
                <ProtectedRouteStudent>
                  <StudentNavbar />
                  <NewUpload />
                </ProtectedRouteStudent>
              }
            />
            {/* t&c */}
            <Route
              path="hiring/student/t&c"
              element={
                <ProtectedRouteStudent>
                  <TermsAndConditions />
                </ProtectedRouteStudent>
              }
            />

            {/* New */}
            <Route
              path="hiring/student/companyProfile"
              element={
                <ProtectedRouteStudent>
                  <StudentNavbar />
                  <CompanyProfile />
                </ProtectedRouteStudent>
              }
            />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
